/*
 * Copyright (c) 2025 Étienne FOLIO
 * Tous droits réservés.
 *
 * Ce fichier fait partie d'un logiciel propriétaire.
 * Toute reproduction, modification ou distribution, totale ou partielle,
 * de ce fichier est interdite sans l'autorisation écrite préalable
 * de l'auteur.
 */

import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Erreur interceptée par ErrorBoundary', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="alert alert-danger" role="alert">
          Une erreur est survenue dans cette section.
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
